import { ApiError } from '@bridebook/toolbox/src/api/api-error';
import { FetchyError } from '@bridebook/toolbox/src/fetchy';
import { TFunction } from 'next-i18next';
import { ShowroundErrorCode } from '../../constants/error-codes';

const knownErrorCodes: string[] = Object.values(ShowroundErrorCode);

const getErrorMessage = (error: ApiError | Error | string): string => {
  // Fetchy keeps the API error code in the response body, not in the message.
  // Only known codes are lifted so other server strings never reach the user.
  if (error instanceof FetchyError) {
    const body = error.body;
    const bodyMessage = typeof body === 'object' ? body.message : undefined;
    if (typeof bodyMessage === 'string' && knownErrorCodes.includes(bodyMessage)) {
      return bodyMessage;
    }
    return error.message;
  } else if (error instanceof ApiError) {
    return error.message;
  } else if (error instanceof Error) {
    return error.message;
  } else if (typeof error === 'string') {
    return error;
  }
  return 'An error occurred';
};

export const getUserFriendlyErrorMessage = (
  error: ApiError | Error | string,
  t: TFunction,
): string => {
  const apiErrorMessage = getErrorMessage(error);

  if (apiErrorMessage.includes(ShowroundErrorCode.ALREADY_BOOKED_BY_CURRENT_WEDDING)) {
    return t('showrounds:showround.already_booked_by_current_wedding');
  }

  if (apiErrorMessage.includes(ShowroundErrorCode.ALREADY_BOOKED_AT_SAME_TIME)) {
    return t('showrounds:showround.already_booked_at_same_time');
  }

  if (apiErrorMessage.includes(ShowroundErrorCode.CANNOT_BOOK_IN_THE_PAST)) {
    return t('showrounds:showround.cannot_book_in_the_past');
  }

  if (apiErrorMessage && apiErrorMessage.length < 200 && !apiErrorMessage.includes('Error:')) {
    return apiErrorMessage;
  }

  return t('showrounds:showround.error');
};
